import { listBackupRestores } from '@qdrant/qdrant-cloud-public-api/serverless/space/backup/v1/connect-query';
import { createFileRoute } from '@tanstack/react-router';
import { assertPermissionsWithoutRpc } from '@/api/permissions';
import { spaceBackupService } from '@/api/services/serverless/space-backup';
import { resolveAccountHasRpcPermissions } from '@/router/resolvers/user';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections',
)({
  // The space data plane enforces `read:serverless_data` on the list and every collection, and no RPC declares
  // it, so no fetch here refuses in its place: check it up front and render Access Denied instead of a failed
  // request.
  beforeLoad: ({ context: { queryClient }, params: { accountId, spaceId } }) => {
    assertPermissionsWithoutRpc(['read:serverless_data'], { queryClient, accountId });

    return {
      listBackupRestoresQuery: spaceBackupService.listBackupRestoresQuery({ accountId, spaceId }),
      // The running restore's backup: a collection backup restores that collection only.
      getBackupQuery: (backupId: string) => spaceBackupService.getBackupQuery({ accountId, backupId }),
    };
  },
  // A running restore is the only signal a collection is not readable yet. Not awaited, and only when readable:
  // without it the collections render as if no restore runs.
  loader: async ({ context: { queryClient, listBackupRestoresQuery }, params: { accountId } }) => {
    if (await resolveAccountHasRpcPermissions([listBackupRestores], { queryClient, accountId })) {
      void queryClient.prefetchQuery(listBackupRestoresQuery);
    }
  },
});
